module.exports = __webpack_public_path__ + "static/media/XLcykel.465ff8cf.jpeg";